var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Chip from '.';
import { ChipGroupBase } from './styled';
export function ChipGroup(_a) {
    var { id, options, type, checked, onChange, variant = 'scroll' } = _a, props = __rest(_a, ["id", "options", "type", "checked", "onChange", "variant"]);
    function handleChange(event, option) {
        const { value } = event.target;
        const checkedOptions = checked.map((v) => options.find((o) => o.value === v));
        if (type === 'choice') {
            onChange([value], [option]);
        }
        else if (checked.includes(value)) {
            onChange(checked.filter((v) => v !== value), checkedOptions.filter((v) => v.value !== value));
        }
        else {
            onChange([...checked, value], [...checkedOptions, option]);
        }
    }
    return (React.createElement(ChipGroupBase, Object.assign({ variant: variant, role: "group" }, props), options.map((option) => (React.createElement(Chip, Object.assign({ name: id }, option, { type: type, key: option.value, value: option.value, checked: checked.includes(option.value), onChange: (event) => handleChange(event, option) }))))));
}
export default ChipGroup;
